function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

var ArticleListComponent = function (_React$Component) {
  _inherits(ArticleListComponent, _React$Component);

  function ArticleListComponent() {
    _classCallCheck(this, ArticleListComponent);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ArticleListComponent.prototype.render = function render() {
    var _props = this.props,
        t = _props.t,
        onArticleOpen = _props.onArticleOpen,
        thumbnailClassName = _props.thumbnailClassName,
        color = _props.color,
        thumbnail = _props.thumbnail,
        article = _props.article,
        loadImage = _props.loadImage,
        validTitle = _props.validTitle,
        cleanText = _props.cleanText;
    return React.createElement('div', {
      className: thumbnailClassName + (thumbnail ? ' articleList--withThumbnail' : '') + ' articleList--entry clearfix',
      onMouseOver: function onMouseOver() {
        return article.olFeature.set('hover', true);
      },
      onMouseOut: function onMouseOut() {
        return article.olFeature.set('hover', false);
      },
      style: {
        borderTop: '6px solid ' + color
      }
    }, loadImage ? React.createElement('img', {
      'data-original': thumbnail,
      src: thumbnail,
      className: 'loaded'
    }) : React.createElement('img', {
      'data-original': thumbnail
    }), React.createElement('div', {
      className: 'caption'
    }, validTitle(article.properties.title) && React.createElement('h4', null, article.properties.title), React.createElement('div', {
      className: 'articleList--content',
      dangerouslySetInnerHTML: {
        __html: cleanText(article.properties.content)
      }
    }), React.createElement(Button, {
      bsStyle: 'link',
      className: 'pull-right',
      onClick: function onClick() {
        return onArticleOpen(article);
      }
    }, t('ReadMore'))));
  };

  return ArticleListComponent;
}(React.Component);

export { ArticleListComponent as default };
ArticleListComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  t: PropTypes.func.isRequired,
  onArticleOpen: PropTypes.func.isRequired,
  thumbnailClassName: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
  article: PropTypes.object.isRequired,
  validTitle: PropTypes.func.isRequired,
  cleanText: PropTypes.func.isRequired,
  loadImage: PropTypes.bool
} : {};